type Ref<T> = React.RefCallback<T> | React.RefObject<T> | null

export function composeRefs<T>(
  ...refs: (Ref<T> | undefined)[]
): React.RefCallback<T> {
  return (instance: T) => {
    refs.forEach((ref) => {
      if (typeof ref === 'function') {
        ref(instance)
      } else if (ref !== null && typeof ref === 'object' && 'current' in ref) {
        ;(ref as React.RefObject<T>).current = instance
      }
    })
  }
}
